import styles from './OutletDetail.css'
import {clickCancel, submitFormCreate, submitFormUpdate} from 'actions/outletPages/list'
import OutletForm from './OutletForm'
import {askConfirmAction} from 'actions/confirm-action'
import {isDirty} from 'redux-form'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {push} from 'react-router-redux'

class OutletDetail extends React.Component {
  componentDidMount () {
    browserHistory.listenBefore((location) => {
      if (this.props.isDirtyForm && !this.props.nextAction) {
        // negate the change location, instead use sagas to handle the change location
        this.props.dispatch(askConfirmAction(push(location.pathname)))
        return false
      }
    })
  }

  render () {
    return (<div className={styles.wrapper}>
      <div className={styles.form}>
        <OutletForm
          onSubmit={this._onSubmit}
          onClickCancel={this._onClickCancel}
        />
      </div>
    </div>)
  }

  _onClickCancel = () => {
    this.props.dispatch(clickCancel())
  };

  _onSubmit = (values) => {
    const {outlets} = this.props
    const data = {}
    data.name = values.name.trim()
    data.address = values.address.trim()
    data.phone_number = `0${values.phone.trim()}`
    data.city = values.city.trim()
    data.province = values.province.trim()
    data.postal_code = values.postal.trim()
    data.business_id = values.businessId
    if (values.id) {
      this.props.dispatch(submitFormUpdate(values.id, {outlet: data}, {}, outlets))
    } else {
      this.props.dispatch(submitFormCreate({outlet: data}, {}, outlets))
    }
  }
}

OutletDetail.propTypes = {
  outlet: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array,
  isDirtyForm: React.PropTypes.bool,
  nextAction: React.PropTypes.object
}

function mapStateToProps (state) {
  return {
    isDirtyForm: isDirty('outlet')(state),
    nextAction: state.confirmAction.nextAction
  }
}

export default connect(mapStateToProps)(OutletDetail)



// WEBPACK FOOTER //
// ./app/pages/Outlets/List/OutletDetail/OutletDetail.js